/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#dropdownLang[_ngcontent-%COMP%]{padding:8px 10px;text-transform:none}#dropdownLang[_ngcontent-%COMP%]::after{margin-left:.8em}"];
export { styles as styles };
